export default "__VITE_ASSET__DzrLEF2b__"